// components/BackNavigationHandler.jsx

import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { LogOut } from "lucide-react";

import "./BackNavigationHandler.scss";

export default function BackNavigationHandler() {
    const location = useLocation();

    const [showExitModal, setShowExitModal] = useState(false);

    // true enquanto a "armadilha" de proteção está armada (esperando um
    // gesto de voltar pra mostrar o modal). false depois que o usuário
    // confirma a saída — nesse momento deixamos o back acontecer de verdade,
    // sem reancorar de novo.
    const isArmed = useRef(true);

    const isDashboard =
        location.pathname === "/dashboard-freelancer" ||
        location.pathname === "/dashboard-company";

    useEffect(() => {
        if (!isDashboard) return;

        // Reseta a cada vez que entra no dashboard (ex: logou de novo depois
        // de ter saído antes) — sem isso, isArmed ficaria travado em false
        // pra sempre depois da primeira saída confirmada.
        isArmed.current = true;

        window.history.pushState(
            { protectedBack: true },
            "",
            window.location.href
        );

        const handlePopState = () => {
            if (!isArmed.current) return; // usuário já confirmou saída — deixa passar

            // Rearma a proteção: o navegador já consumiu a entrada de proteção
            // ao voltar, então empurramos uma nova por cima antes de mostrar o modal.
            window.history.pushState(
                { protectedBack: true },
                "",
                window.location.href
            );

            setShowExitModal(true);
        };

        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [isDashboard, location.pathname]);

    const handleCancel = () => {
        setShowExitModal(false);
        // Não precisa fazer nada com o histórico aqui — a proteção já foi
        // reancorada dentro do handlePopState antes do modal aparecer.
    };

    const handleExitApp = () => {
        isArmed.current = false; // desarma: o próximo popstate não deve reancorar
        setShowExitModal(false);

        // Um único passo: desfaz a entrada de proteção e deixa o gesto de
        // voltar original (que interceptamos) finalmente acontecer.
        // Se isso esgotar o histórico (app aberto direto como PWA instalado,
        // em modo standalone), o próprio Android trata isso como "sair do
        // app" — não tem comando de JS que force isso, é comportamento
        // nativo do navegador/SO quando o histórico chega a zero.
        window.history.back();
    };

    if (!showExitModal) return null;

    return (
        <div className="logout-modal-overlay">
            <div className="logout-modal">

                <div className="logout-modal-icon">
                    <LogOut size={24} />
                </div>

                <h2>Sair do aplicativo?</h2>

                <p>
                    Deseja realmente sair do aplicativo?
                </p>

                <div className="logout-modal-actions">

                    <button
                        onClick={handleCancel}
                    >
                        Cancelar
                    </button>

                    <button
                        onClick={handleExitApp}
                    >
                        Sair
                    </button>

                </div>
            </div>
        </div>
    );
}